import { Action } from '@ngrx/store';

export const PAGE_LOADING = '[UI] Page Loading';
export const PAGE_LOADED = '[UI] Page Loaded';
export const SHOW_ERROR = '[UI] Show Error';


export class PageLoaded implements Action {
    readonly type = PAGE_LOADED;
}

export class PageLoading implements Action {
    readonly type = PAGE_LOADING;
}

export class ShowError implements Action {
    readonly type = SHOW_ERROR;
    constructor(public payload: any) {}
}


export type uiActions = PageLoaded |
                        PageLoading |
                        ShowError;



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/actions/ui.action.ts